import { List, Record } from 'immutable';

export const MembersList = new Record({
  id: null,
  isNew: true,
  isPending: false,
  itemsId: new List(),
  error:null
});
